import axiosClient from "api/axiosClient"
import {
  SimilarNomenclatureResponse,
  SimilarNomenclatureSearch,
} from "type/mapping/similarNomenclature"

export const getSimilarNomenclatures = async (
  body: SimilarNomenclatureSearch,
): Promise<SimilarNomenclatureResponse> => {
  const { data: similarNomenclatures } = await axiosClient.post(
    "/mapping/result/similar_nomenclatures",
    body,
  )
  return similarNomenclatures
}
